import moment from "moment/moment";
import config from "config/config";
import { getToken } from "js/formatting/getToken";
import { isAgentPortal } from "js/utilities";

export async function getAlerts(policies, user) {
  const isAnnuityPayoutIndicatorFlag = policies
    ? policies?.find((p) => p.annuityPayoutIndicatorFlag === "Y")
    : undefined;
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": config.ODS_API_KEY,
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      gXdpApi: {
        transactionType: {
          eventName: "GETALERT",
          sourceNameSpace: "LIFESYS",
          targetNameSpace: "GIDP",
          operation: "GET",
        },
        gIdpPayLoad: {
          policyHolder: {
            phoneNumber: "",
            contractId: "",
            taxId:
              isAnnuityPayoutIndicatorFlag && !isAgentPortal()
                ? user?.identityNumber
                : "",
            contractId_array: policies.map((policy) => policy.contractID),
            dateOfBirth: "",
          },
          addOnProperties: {
            lifesys: {
              policyHolder: {
                company: config.COMPANY,
                clientName: config.CLIENTNAME,
                system: "LSN",
                lifeSysDataset: "P",
                searchType: "IN",
                requestDomesticViolenceFlag: "",
                recordsRequested: 100,
                dvInclude: "",
                includecomplianceFlag: "",
                contractExpiryDuration: "",
                suppressRider: "",
                clientGroupSeach: "",
                ShowTotalRequestTime: "",
              },
            },
          },
        },
        parentCorrelationID: moment().format("YYYY-MM-DD HH:MM:SS"),
        correlationID: moment().format("YYYY-MM-DD HH:MM:SS"),
        addOnProperties: {},
      },
    }),
  };
  const response = await fetch(
    config.ODS_API_BASE_URL + "/evl/GetAlert",
    options
  );

  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    if (data?.gXdpApi?.success) {
      return data.gXdpApi;
    }
    return;
  }
}
